module.exports = __webpack_public_path__ + "images/for_company_page/hintos_8906f5772766791df71a0b79e3d5d8ce.png";